<template>
  <div class="notification-container" v-if="notifications.length > 0">
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar.vue";
import { mapState } from "vuex";

export default {
  components: {
    NotificationBar,
  },
  computed: mapState("notification", ["notifications"]),
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 9931622979;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  text-align: center;
}
</style>
